<template>
  <a-tooltip :content="hint">
    <a-tag :color="color" size="small">{{ label }}</a-tag>
  </a-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { normalizeEnterpriseSource } from './enterprise-source'

/** 来源由企业主表向下传递，禁止根据明细是否存在推断来源。 */
const props = defineProps<{ externalSource?: string; loading?: boolean }>()
const { t } = useI18n()
const source = computed(() => normalizeEnterpriseSource(props.externalSource))
const label = computed(() => t(props.loading ? 'company.source.loading' : source.value === 'manual'
  ? 'company.source.manual' : source.value === 'mdm' ? 'company.source.mdm'
    : source.value === 'cargoware' ? 'company.source.cargoware' : 'company.source.unknown'))
const color = computed(() => source.value === 'manual' ? 'green' : source.value === 'mdm' ? 'arcoblue' : 'gray')
const hint = computed(() => t(props.loading ? 'company.source.loadingHint' : source.value === 'manual'
  ? 'company.source.manualHint' : source.value === 'mdm' ? 'company.source.mdmReadOnly'
    : source.value === 'cargoware' ? 'company.source.cargowareHint' : 'company.source.unknownHint'))
</script>
